<template>
  <div>
    <top-bar @changeEmpresa="changeEmpresa()"/>
    <div class="content">
      <div class="container-fluid">
        <loading v-show="load"/>
        <div v-show="!load">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h1 class="h3 mb-0 text-gray-800">Contatos</h1>
          </div>
          <modal-menu class="mb-3" :menus="menus" :selected="menu" @changeMenu="toggleMenu"/>
          <div v-show="menu === 1">
            <div class="text-center text-md-left mb-4 mb-md-3">
              <div class="row">
                <div class="col-md-9">
                  <div class="position-relative">
                    <i class="fa fa-search" style="position: absolute; top: 11px; left: 11px"></i>
                    <input id="atendiment" type="search" placeholder="Pesquisar contato" @keyup.enter="buscarClientes(0, true)" @search="buscarClientes(0, true)" v-model="pesquisa.termo"
                           class="form-control rounded" style="padding-left: 36px" :disabled="pesquisa.relatorio !== '1'"/>
                  </div>
                </div>
                <div class="col-md-3 d-md-block mt-3 mt-md-0" :class="{'d-none': !filter}">
                  <select class="form-control mb-0" @change="buscarClientes(0)" v-model="pesquisa.relatorio">
                    <option value="1">Todos os Clientes</option>
                    <option value="2">Clientes que interagiram nos últimos 30 dias</option>
                    <option value="3">Clientes ausentes (+30 dias sem interagir)</option>
                    <option value="4">Clientes perdidos (+60 dias sem interagir)</option>
                    <option value="5">Clientes que nunca compraram</option>
                    <option value="6">Clientes bloqueados</option>
                    <option value="7">Clientes em atendimento</option>
                  </select>
                </div>
                <div class="col-12 d-md-none mt-3">
                  <button class="btn btn-warning text-white px-4" @click="filter = !filter">Filtros <i class="fa ml-1" :class="filter ? 'fa-minus' : 'fa-plus'"></i></button>
                </div>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body">
                <div class="d-none d-md-block">
                  <div class="row no-gutters mb-2 pb-2 border-bottom">
                    <div class="col-md-8 small font-weight-bold">Contato</div>
                    <div class="col-md-4 small text-right font-weight-bold">Última Mensagem</div>
                  </div>
                </div>
                <a href="javascript:" class="row no-gutters contato-item" v-for="c in clientes" @click="viewCliente(c)">
                  <div class="col-md-8 d-flex align-items-center">
                    <div class="user mr-3"><i class="fa fa-user"></i></div>
                    <div>
                      <h6 class="mb-1">{{c.nome_cliente || c.nome_user || 'Sem nome'}}</h6>
                      <div class="small">{{c.telefone | phone}}</div>
                    </div>
                  </div>
                  <div class="col-md-4 small text-right d-none d-md-block text-nowrap">
                    {{c.ultima_msg}}
                    <button class="btn btn-action btn-sm btn-info ml-3"><i class="fa fa-pen"></i></button>
                  </div>
                </a>
                <div class="pt-2 d-flex justify-content-between" v-if="clientes.length">
                  <button class="btn btn-sm btn-outline-dark" @click="buscarClientes(pesquisa.page - 1)" :disabled="!pesquisa.page"><i class="fa fa-angle-left"></i> Anterior</button>
                  <button class="btn btn-sm btn-outline-dark" @click="buscarClientes(pesquisa.page + 1)" :disabled="clientes.length < pesquisa.bloco">Próximo <i class="fa fa-angle-right"></i></button>
                </div>
                <div class="text-center py-4" v-else>
                  Esta busca retornou nenhum resultado
                </div>
              </div>
            </div>
          </div>
          <div v-show="menu === 2">
            <div class="text-right mb-3"><button class="btn btn-primary" @click="editarGrupo()"><i class="fa fa-plus"></i> Novo Grupo</button></div>
            <div class="card shadow-sm mb-4">
              <div class="card-body">
                <div v-if="grupos.length">
                  <div class="d-none d-md-block border-bottom small font-weight-bold pb-2 mb-2">Nome do Grupo</div>
                  <a href="javascript:" class="row no-gutters contato-item" v-for="g in grupos">
                    <div class="col-md-8 d-flex align-items-center" @click="editarGrupo(g)">
                      <div class="user mr-3"><i class="fa fa-users"></i></div>
                      <div>
                        <h6 class="mb-1">{{g.nome_grupo}}</h6>
                        <div class="small">Contatos: {{ g.contatos.length || '0'}}</div>
                      </div>
                    </div>
                    <div class="col-md-4 small text-right d-none d-md-block text-nowrap">
                      <button class="btn btn-action btn-dark btn-sm mr-1" @click="removerGrupo(g)"><i class="fa fa-trash-alt"></i></button>
                      <button class="btn btn-action btn-info btn-sm" @click="editarGrupo(g)"><i class="fa fa-pen"></i></button>
                    </div>
                  </a>
                </div>
                <div class="text-center py-4" v-else>
                  Não há grupos cadastrado
                </div>
              </div>
            </div>
          </div>
        </div>

        <modal :opened="modalCliente" @fechar="modalCliente = false" :preview="menu === 1" @salvar="salvarGrupo">
          <div v-show="menu === 1">
            <cliente-formulario ref="contato" @editarContato="editarContato" @goHome="$emit('goHome')" @close="modalCliente = false" :token="token"/>
          </div>
          <div v-show="menu === 2" v-if="dadosGrupo">
            <loading v-if="loadModal"/>
            <div v-show="!loadModal">
              <div class="text-center">
                <div class="user mx-auto"><i class="fa fa-users"></i></div>
              </div>
              <div class="mb-2">
                <label class="mb-0"><b>Nome do Grupo</b></label>
                <input class="form-control" id="nomeGrupo" v-model="dadosGrupo.nome_grupo" placeholder="Ex: Cliente especiais"/>
              </div>
              <modal-menu class="border-0 mb-0" :menus="menusG" :selected="menuG" @changeMenu="(m) => {this.menuG = m}"/>
              <div class="card table-responsive">
                <div class="py-2 px-3 mb-2" v-show="menuG === 1">
                  <div class="row no-gutters align-items-end" v-if="gContato">
                    <div class="col-5">
                      <label class="mb-0 font-weight-bold small">Nome</label>
                      <input class="form-control" id="nomeContato" placeholder="Ex Gustavo" v-model="gContato.nome_user">
                    </div>
                    <div class="col-5 pl-1">
                      <label class="mb-0 font-weight-bold small">Telefone</label>
                      <the-mask :mask="['(##) ####-####', '(##) #####-####']" class="form-control" placeholder="(##) #####-###" minlength="8" v-model="gContato.telefone" @keyup.enter.native="validarContatoGrupo"/>
                    </div>
                    <div class="col-2 text-center pl-1">
                      <button class="btn btn-primary btn-block" @click="validarContatoGrupo()"><i class="fa fa-plus"></i></button>
                    </div>
                  </div>
                </div>
                <div class="p-3" v-show="menuG === 2">
                  <div class="small">
                    <div><i class="fa fa-info-circle text-warning mr-1"></i>Formato CSV. Limite 500 contatos. <a href="https://lecard.tawk.help/article/como-importar-uma-planilha-de-contatos-para-o-lebot" target="_blank" class="text-nowrap">Saiba mais</a></div>
                    <div class="mt-2"><input type="file" id="CsvContatos" accept=".csv" @change="uploadCSV"/></div>
                  </div>
                </div>
                <div class="height-50 border-top" v-show="dadosGrupo.contatos.length">
                  <div class="bg-light text-center p-1" v-if="dadosGrupo.contatos.length">
                    Contatos: {{dadosGrupo.contatos.length}}
                  </div>
                  <div class="row align-items-center no-gutters border-top px-3 py-2" v-for="c in dadosGrupo.contatos">
                    <div class="col-5 small">{{c.nome_user}}</div>
                    <div class="col-5 small">{{c.telefone | phone}}</div>
                    <div class="col-2 text-right">
                      <button class="btn btn-action text-dark btn-sm" title="Remover" @click="removerContatoGrupo(c)"><i class="fa fa-trash"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/commons/TopBar";
import Modal from "@/components/commons/Modal";
import Loading from "@/components/commons/Loading";
import ClienteFormulario from "@/components/clientes/ClienteFormulario";
import ModalMenu from "@/components/commons/ModalMenu";

export default {
  name: 'Contatos',
  components: {ModalMenu, TopBar, ClienteFormulario, Loading, Modal},
  data() {
    return {
      token: localStorage.getItem('key'),
      clientes: [],
      load: false,
      loadModal: false,
      menu: 1,
      menus: [{ nome: 'Contatos', active: true },{ nome: 'Grupos', active: true }],

      menuG: 1,
      menusG: [{ nome: 'Contatos', active: true },{ nome: 'Importar', active: true }],
      grupos: [],
      dadosGrupo: null,
      gContato: null,

      pesquisa: {
        order: '2',
        relatorio: '1',
        termo: '',
        bloco: 100,
        page: 0
      },

      filter: false,
      modalCliente: false
    }
  },

  methods: {
    editarContato(id_chatbot_user, nome_user) {
      const dados = this.clientes.find(c => c.id_chatbot_user === id_chatbot_user);

      if (dados) {
        dados.nome_user = nome_user;
      }
    },

    viewCliente(c) {
      this.modalCliente = true;

      if (c.id_chatbot_user) {
        this.$refs.contato.selContato(c.id_chatbot_user);

      } else {
        this.$refs.contato.selCliente(c.id_cliente);
      }
    },

    buscarClientes(page, clear) {
      if (this.load) {
        return;
      }

      this.load = true;
      this.pesquisa.page = page || this.pesquisa.page;

      if (clear) {
        this.pesquisa.page = 0;
      }

      this.$http.get('chatbot/contatos/' + this.token, {params: this.pesquisa})
        .then(response => {
          this.load = false;
          this.clientes = response.data || [];

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    toggleMenu(m) {
      this.menu = m;

      if (m === 2 && !this.grupos.length) {
        this.buscarGrupos();
      }
    },

    buscarGrupos() {
      this.load = true;
      this.$http.get('chatbot/grupos/' + this.token)
        .then(response => {
          this.load = false;
          this.grupos = response.data || [];

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
    },

    editarGrupo(g) {
      if (!g && this.grupos.length >= 6) {
        this.$swal("No momento você pode cadastrar até 6 grupos de contatos.");
        return;
      }

      this.dadosGrupo = {
        id_grupo: g ? g.id_grupo : null,
        nome_grupo: g ? g.nome_grupo : '',
        contatos: g ? g.contatos : []
      }

      this.gContato = { nome_user: '', telefone: '' };
      this.modalCliente = true;
      this.$nextTick(() => {
        this.$helpers.focusElement('nomeGrupo');
      });
    },

    removerGrupo(g) {
      this.$swal({
        text: `Deseja realmente remover este grupo de contatos?`,
        buttons: ["Voltar", "Sim"],
        dangerMode: true,
      }).then(res => {
        if (res) {
          this.dadosGrupo = g;
          this.dadosGrupo.contatos = [];
          this.dadosGrupo.remover = true;
          this.salvarGrupo();
        }
      });
    },

    salvarGrupo() {
      this.loadModal = true;
      this.$http.post('chatbot/grupos/' + this.token, this.dadosGrupo).then(() => {
        this.loadModal = false;
        this.modalCliente = false;
        this.buscarGrupos();

      }, res => {
        this.loadModal = false;
        this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
      });
    },

    validarContatoGrupo() {
      if (this.gContato.nome_user.trim().length && this.gContato.telefone.length >= 10) {
        const contato = this.dadosGrupo.contatos.find(c => c.telefone === this.gContato.telefone);

        if (contato) {
          this.$swal({
            text: `Este contato já está no grupo. Deseja substituir?`,
            buttons: ["Não", "Sim"],
            dangerMode: true,
          }).then(res => {
            if (res) {
              this.removerContatoGrupo(contato);
              this.addContatoGrupo();
            }
          });

          return;
        }

        this.addContatoGrupo();

      } else {
        this.$swal("Por favor, informe um nome e telefone válido.");
      }
    },

    addContatoGrupo() {
      this.dadosGrupo.contatos.push(this.gContato);
      this.gContato = null;
      this.$nextTick(() => {
        this.gContato = { nome_user: '', telefone: '' };
        this.$nextTick(() => { this.$helpers.focusElement('nomeContato'); });
      });
    },

    removerContatoGrupo(contato) {
      this.dadosGrupo.contatos = this.dadosGrupo.contatos.filter(c => c !== contato);
    },

    changeEmpresa() {
      this.grupos = [];
      this.token = localStorage.getItem('key');
      this.buscarClientes(0);
      this.toggleMenu(this.menu);
    },

    uploadCSV(evt) {
      let reader = new FileReader();
      reader.readAsText(evt.target.files[0]);
      reader.onload = () => {
        this.dadosGrupo.contatos = [];
        reader.result.split('\n').forEach((line, index) => {
          if (index > 0 && index <= 501) {
            const contato = line.split(';');

            if (contato && contato.length >= 2) {
              const nome_user = contato[0].trim().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
              const telefone = contato[1].trim().replace(/[^0-9]/g,'');

              if (nome_user.length > 2 && telefone.length >= 10 && telefone.length <= 11 && !this.dadosGrupo.contatos.find(c => c.telefone === telefone)) {
                this.dadosGrupo.contatos.push({ nome_user, telefone });
              }
            }
          }
        });
      }
    }
  },

  mounted() {
    this.buscarClientes(0);
  },

  computed: {
    wpp_session() {
      return this.$store.state.wpp_session
    }
  }
}
</script>
<style scoped>
  .user {
    background-color: #6c757d;
    color: #FFFFFF;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  input[disabled] {
    cursor: not-allowed;
  }

  .contato-item {
    text-decoration: none;
    border-bottom: 1px solid #e3e6f0;
    margin-bottom: 8px;
    padding: 2px 0 10px 0;
    align-items: center;
    color: #1b1e21;
  }

  .contato-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  .height-50 {
    height: calc(100vh - 405px);
  }
</style>